/**************************************************************************************************/
/*   File: /src/app/stores/index.ts                                                               */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Tuesday February 5th 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Feb 22 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import * as actions from './actions/index';
import * as effects from './effects/index';
import * as reducers from './reducers/index';
import * as selectors from './selectors/index';
import * as states from './states/index';

export {
    actions,
    effects,
    reducers,
    selectors,
    states
};